import React from 'react';
import {List, Datagrid, TextField, ShowButton, EditButton} from 'react-admin';
import CashbackItemsField from './CashbackItemsField';

class CashbackConditionsList extends React.Component {
    render() {
        return (
            <List {...this.props}>
                <Datagrid rowClick="edit">
                    <TextField source="id" />
                    <TextField source="position" />
                    <TextField source="margin" />
                    <TextField source="fontSize" label="Font Size" />
                    <CashbackItemsField limit={4} />
                    <ShowButton />
                    <EditButton />
                </Datagrid>
            </List>
        );
    }
}

export default CashbackConditionsList;
